import { QueovalBase } from '../global';
import { Dictionary } from 'lodash';

export class BaseQuestionnaireModel extends QueovalBase {
  public listModel: Array<Model>;
  public questionnaireModel: QuestionnaireModel;
  public showConvertionBtn: boolean;
  public StageByModel: Array<any>;

  constructor() {
    super();
    this.questionnaireModel = new QuestionnaireModel();
  }
}

export class Model {
  public ident: string;
  public isElearning: boolean;
  public questionnaireType: number;
  public titre: string;
  public model: string;
  public description: string;
  public nbQuesiton: number;
  public dateDerniereModif: Date;
  public CanBeConverted: boolean;

  constructor() {
    this.ident = '0';
    this.isElearning = false;
    this.questionnaireType = 0;
    this.titre = '';
    this.model = '';
    this.description = '';
    this.nbQuesiton = 0;
    this.dateDerniereModif = new Date();
    this.CanBeConverted = false;
  }
}

export class AnswerModel extends QueovalBase {
  public fileToDl: string;
  public learnerList: Array<LearnerDetail>;
  public questionnaireModel: QuestionnaireModel;
  public numPageSave: number;
  public formateurName: string;
  public nbElement: number;
  public stageId: string;
  public learnerId: string;
  public modelType: string;
  public modelName: string;
  public readOnly: boolean;
  public modeQuestionnaire: string;
  public facebookLink: string;
  public twitterLink: string;
  public viadeoLink: string;
  public googlePlusLink: string;
  public linkedInLink: string;
  public lessonId: string;
  public etatQuestionnaire: string; 
  public isEmailing: boolean;
  public isTrainer: boolean;
}

export class CreateModel extends QueovalBase {
  public questionnaireModel: QuestionnaireModel;
  public deletedElement: Array<string>;
  public modelName: string;
  public nbElement: number;
  public readOnly: boolean;
  public modeQuestionnaire: string;
}



export class QuestionnaireModel {
  public ident: string;
  public isElearning: boolean;

  public certification: QuestCertification;

  public questionnaireType: number;
  public titre: string;
  public modelQuestionnaire: string;
  public description: string;
  public messageFin: string;
  public note: number;
  public notePassage: number;
  public noteMax: number;
  public nbQuestion: number;
  public pagination: Array<QuestPage>;
  public group: Array<QuestGroup>;
  public filterBo: Array<QuestPropFilter>;
  constructor() {
    this.ident = '0';
    this.titre = '';
    this.description = '';
    this.messageFin = '';
    this.notePassage = 0;
    this.noteMax = 0;
    this.nbQuestion = 0;
    this.pagination = [];
    this.group = [];
    this.certification = new QuestCertification();
    this.filterBo= new Array<QuestPropFilter>();
  }
}

export class QuestGroup {
  public groupName: string;
  public groupPoint: number;
  public groupPointMax: number;
  public groupPointMaxRng: number;
  public groupElements: Array<QuestElement>;
  public isRandom: boolean;
  public randomEl: number;
  constructor() {
    this.groupElements = [];
    this.groupPointMax = 0;
    this.isRandom = false;
    this.randomEl = 0;
  }
}

export class QuestPage {
  public numPage: number;
  public pageReadOnly: boolean;
  public idPage: number;
  public IsActive: boolean;
  public elements: Array<QuestElement>;
  constructor() {
    this.IsActive = false;
    this.elements = [];
    this.pageReadOnly = false;
  }
}

export class QuestElement {
  public ident: string;
  public type: string;
  public text: string;
  public optionType: string;
  /*----------------------*/
  public hint: boolean;
  public hintCorrect: string;
  public hintWrong: string;
  /*----------------------*/
  public commentaire: boolean;
  public commentaireTxt: string;
  /*----------------------*/
  public plusOption: boolean;
  /*----------------------*/
  public point: number;
  public maxPoint: number;
  public required: boolean;
  /*----------------------*/
  public options: Array<Option>;
  public idEl: number;
  public IsActive: boolean;

  public mediaId: string;
  public mediaPath: string;
  public mediaType: string;

  public mediaOption: boolean;

  public ctrlType: string;
  public ctrlValue: string;

  public groupName: string;
  public groupPoint: number;
  public groupRandom: number;

  constructor() {
    this.ident = '0';
    this.IsActive = false;
    this.type = '';
    this.text = '';
    this.options = [];
    this.required = true;
    this.mediaOption = false;
    this.plusOption = this.commentaire || this.hint;
  }
}

export class Option {
  public ident: string;
  public text: string;
  public answer: string;
  public point: number;
  public isCorrectAnswer: boolean;
  public gapsFill: Array<GapFill>;
  public gapsFillProposal: Array<GapFillProposal>;
  public ordre: number;

  public mediaId: string;
  public mediaPath: string;
  public mediaType: string;

  public ctrlType: string;
  public ctrlValue: string; 

  public msg: string;
  public redir: number;

  constructor() {
    this.ident = '0';
    this.text = '';
    this.isCorrectAnswer = false;
    this.ctrlValue = '';
    this.gapsFill = new Array<GapFill>();
    this.gapsFillProposal = new Array<GapFillProposal>();
  }
}

export class GapFill {
  public isCorrect: boolean;
  public isAnswer: boolean;
  public text: string;
  public answer: string;
  constructor() {
    this.isAnswer = false;
  }
}

export class GapFillProposal {
  public text: string;
  public isAnswer: boolean;
}

export enum ModeQuestion {
  create = 'create',
  cDiplay = 'createDisplay',
  reply = 'reply',
  rDiplay = 'replyDisplay'
}

export class MatchingQuestionOption {
  public dragId: string;
  public dropId: string;
  public color: string;
}
export class LearnerDetail {
  ident: string;
  name: string;
  firstname: string;
  questionnaireCompleted: boolean;
  note: number;
  noteMax: number;
  notePassage: number;
  isChecked: string;
  questValid: boolean;
}

export class QuestCertification {
  isCertification: boolean;
  tempsCertification: number;
  maxTempsCertification: number;
  dateValidation: Date;
  etatCertification: number;
  idSavedQuestionnaire: string;
  timed: boolean;
  timeUp: boolean;
  //Si le questionnaire est reouvert alors que le timer n'est pas fini
  questOngoing: boolean;
  //Num de la page de là où il est revouert 
  currentPage: number;

  certificationEnd: boolean;

}
//#region ChartQuestionnaireModel model

export class ChartQuestionnaireModel extends QueovalBase {
  public postModel: ChartPostModel;
  public chart: ChartData[];
  constructor() {
    super();
    this.postModel = new ChartPostModel();
    this.chart = new Array<ChartData>();
  }
}

export class ChartPostModel {
  public idStagiaire: string;
  public idStage: string;
  public idLesson: string;
  public titreQuestionnaire: string;
  public noteMax: number;
}



export class ChartData {
  public question: string;
  public label: string[];
  public data: Data[];
  public barData: Array<any>;
  public chartType: string;
  constructor() {
    this.label = new Array<string>();
    this.data = new Array<Data>();
    this.barData = new Array<any>();
  }
}

export class Data {
  public label: string;
  public data: number[];

  public value: number;
  public name: string;
}


export class QuestPropFilter {
  public propCodeBop: string;
  public propTitle: string;
  public propFilter: boolean;
}

//#endregion
